import { motion } from 'motion/react'
import { useTheme } from 'styled-components'

import { FormatPrice, Text } from '@reveni-io/reveni-ui'

import { heatMapOptions } from '@/metrics/pages/DashboardPage/ShipmentsMetricsContent/constants'

import * as Styles from './styles'

const HeatMapLegend = ({ quintiles, orderBy, currency }) => {
  const theme = useTheme()
  const getValueByOrderBy = value => {
    if ([heatMapOptions.totalOrdersCount, heatMapOptions.incidentsInCustoms].includes(orderBy)) {
      return value.toFixed(0)
    } else if ([heatMapOptions.totalOrderValue, heatMapOptions.averageOrderValue, heatMapOptions].includes(orderBy)) {
      return <FormatPrice currency={currency}>{value}</FormatPrice>
    }
  }

  if (!quintiles || !quintiles?.length) return null

  return (
    <motion.div key={orderBy} initial={{ opacity: 0 }} transition={{ duration: 1 }} animate={{ opacity: 1 }}>
      <Styles.MainContainer>
        <Styles.QuintileContainer>
          <Styles.Color color="#ccc" />
          <Text type="bodyMRegular" color={theme.colors.text.muted}>
            {getValueByOrderBy(0)}
          </Text>
        </Styles.QuintileContainer>
        {quintiles?.map((quintile, index) => (
          <Styles.QuintileContainer key={index}>
            <Styles.Color color={quintile.color} />
            <Text type="bodyMRegular" color={theme.colors.text.muted}>
              {getValueByOrderBy(quintile.value)}
            </Text>
          </Styles.QuintileContainer>
        ))}
      </Styles.MainContainer>
    </motion.div>
  )
}

export default HeatMapLegend
